export default () =>
  import(
    /* webpackChunkName: 'coffee/app/agreement/enterprise' */ './Enterprise'
  );
